import { ILocalizationService, LocalizationSymbols } from '../Localization';
import { ILoyaltyProvider, LoyaltySymbols } from '../Loyalty';
import { IDateHandler, DateHandlerSymbols } from '../Utility';
import { INotificationService, NotificationSymbols } from '../Notification';
import DefaultClubService from './../Club/default-club-service';
import { ActionResult } from '../Common';
import ClubContract from './../Club/club-contract';
import { injectable, inject } from 'inversify';
import { IClubProvider, ClubSymbols } from './../Club';
import { TennisSymbols } from './symbols';

@injectable()
export default class TennisClubService extends DefaultClubService {

    constructor(@inject(ClubSymbols.ClubProvider) clubProvider: IClubProvider,
        @inject(LocalizationSymbols.LocalizationService) localizationService: ILocalizationService,
        @inject(DateHandlerSymbols.DateHandlerService) dateHandler: IDateHandler,
        @inject(LoyaltySymbols.LoyaltyProvider) loyaltyProvider: ILoyaltyProvider,
        @inject(NotificationSymbols.NotificationService) notificationService: INotificationService) {
        super(clubProvider, localizationService, dateHandler, loyaltyProvider, notificationService);
    }

    async GetContractsAsync(): Promise<ActionResult<Array<ClubContract>>> {
        let result = await super.GetContractsAsync();

        if (!result.Success || this._contracts == null) return result;

        await this._localizationService.TranslateManyAsync(Symbol.for("LTContractAccess"), this._contracts);

        return ActionResult.SuccessData(this._contracts);
    }
}